import { get } from 'lodash';
import { createPropsSelectorOrm } from '../utils';

export const getPickupLocations = createPropsSelectorOrm(
  (session, locationCode) =>
    get(session.PickupLocation.withId(locationCode), 'ref')
);
